module.exports = __webpack_public_path__ + "img/no-data-match.f9dba80a.svg";